import React from 'react';
import { connect } from 'react-redux';
import { cx } from 'linaria';
import { getCartItem } from 'features/basket';
import { getArticle } from 'common/selectors';
import { getMeasurementData, getPrice } from 'features/product-info/ducks/selectors';
import { RootReducer } from 'store/root-reducer';
import { hintStyles } from './styles';
import { VisualizeBoxes } from './visualisation/boxes';
import { VisualizeLinearMeters } from './visualisation/linear-meters';
import { getPricePerBox, isBoxProduct, isReelProduct } from './utils';
import { MeasurementData, Price } from '../../types';

export type MeasurementDataProps = {
  qty?: number;
  price?: Price;
  measurementData: MeasurementData;
  classNames?: string;
};

export type PdpMeasurementHintProps = MeasurementDataProps & React.HTMLAttributes<HTMLElement>;

export const MeasurementHint: React.FC<PdpMeasurementHintProps> = ({
  classNames,
  qty,
  price,
  measurementData,
}) => {
  if (!qty || !price || !measurementData) {
    return null;
  }

  const isBoxesMeasure = isBoxProduct(measurementData);
  const isLinearMetersMeasure = isReelProduct(measurementData);

  return (
    <div className={cx(hintStyles, classNames)}>
      {isBoxesMeasure && (
        <VisualizeBoxes qty={qty} boxPrice={getPricePerBox(price)} boxVolume={measurementData.m2PerBox} />
      )}
      {isLinearMetersMeasure && (
        <VisualizeLinearMeters qty={qty} meterPrice={price.main_price} width={measurementData.width} />
      )}
    </div>
  );
};

export const mapStoreToProps = (store: RootReducer): MeasurementDataProps => {
  const productId = getArticle(store);
  const qty = getCartItem(productId)(store)?.quantity || 0;
  const price = getPrice(store);
  const measurementData = getMeasurementData(store) || ({} as MeasurementData);

  return {
    qty,
    price,
    measurementData,
  };
};

export const PdpMeasurementHint = connect(mapStoreToProps)(MeasurementHint);
